/*global $ */
import { Power4, TweenMax } from 'gsap';
import 'gsap/ScrollToPlugin';

import scrollLock from './scrollLock';
import parseHashId from 'helpers/parseHashId';
import setHash from 'helpers/setHash';

export default function scrollToSection (index, sh, kill, t = 1.5) {
  let id = parseHashId(index);

  if ($('html').hasClass('noScroll')) {
    return;
  }

  if (!window.hashTrack) {
    return;
  }

  window.hashTrack = false;
  sh = (typeof sh !== 'undefined') ? sh : false;
  let auto = (typeof kill !== 'undefined') ? kill : true;
  if (id !== '' && id.length > 0) {
    let dest;
    if (id !== '#') {
      dest = $(id).offset().top;
    } else {
      dest = $('body').offset().top;
    }
    // now check if the top is too tall
    if (dest > $(document).height() - $(window).height()) {
      dest = $(document).height() - $(window).height();
    }

    TweenMax.to(window, t, {
      scrollTo: {
        y: (dest) - 75, autoKill: auto,

        onAutoKill: () => {
          if (sh) {
            setHash(id);
          }
          window.hashTrack = true;
        },
      },
      onComplete: () => {
        scrollLock(true);
        TweenMax.delayedCall(0.2, () => {
          scrollLock(false);
          if (sh) {
            setHash(id, true);
          }
          window.hashTrack = true;
        });
      },
      ease: Power4.easeOut,
    });
  } else {
    window.hashTrack = true;
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scrolling/scrollToSection.js